import {TouchableOpacity, View} from "react-native";
import {THEME_COLORS} from "../../common/styles";
import React from "react"
import ReactDOM from 'react-dom';

interface IDropdownProps {
    show: boolean;
    children: JSX.Element;
    onClose: () => void;
    parentRef?: any;
    position?: any;
}

//bottom-left
//bottom-right
//top-left
//top-right

const Dropdown = (props: IDropdownProps) => {
    const {show, onClose, parentRef, position} = props;
    const childPositionStyle = [{position: "absolute", zIndex: 2}];
    if (!show) return <></>;
    if (!!parentRef && parentRef.current) {
        const parentPosition = parentRef.current.getBoundingClientRect();
        var body = document.body,
            html = document.documentElement;
        const windowAvailableHeight =Math.max( body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight );
        const windowAvailableWidth = Math.max( body.scrollWidth, body.offsetWidth,
            html.clientWidth, html.scrollWidth, html.offsetWidth );
        const minDistanceFromRight = windowAvailableWidth - parentPosition.right;
        const minDistanceFromLeft = parentPosition.left;
        const minDistanceFromTop = parentPosition.top;
        const minDistanceFromBottom = windowAvailableHeight - parentPosition.bottom;
        const height = parentPosition.height;
        const dropdownGap = 10;
        const getValidValue = (value) => {
            const minMarginFromScreenBound = 10;
            return value > minMarginFromScreenBound ? value: minMarginFromScreenBound
        };
        const horizontalStyle = minDistanceFromLeft > minDistanceFromRight ? {right: getValidValue(minDistanceFromRight)}
            : {left: getValidValue(minDistanceFromLeft)};
        const verticalStyle = minDistanceFromTop > minDistanceFromBottom ? {bottom: getValidValue(minDistanceFromBottom+dropdownGap+height)}
            : {top: getValidValue(minDistanceFromTop+height+dropdownGap)};

        childPositionStyle.push(horizontalStyle, verticalStyle);
    } else if (position) {
        if (position === "bottom-left") childPositionStyle.push({left: 50, bottom: 50});
        if (position === "bottom-right") childPositionStyle.push({right: 50, bottom: 50});
        if (position === "top-left") childPositionStyle.push({left: 50, top: 50});
        if (position === "top-right") childPositionStyle.push({right: 50, top: 50});
        if (position === "center") childPositionStyle.push({
            position: "static",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        })
    } else {
        childPositionStyle.push({flexDirection: 'row', justifyContent: 'center'})
    }

    const appRoot = document.body;
    return ReactDOM.createPortal(
        <View style={{
            position: 'absolute', top: 0, left: 0, bottom: 0, right: 0,
            flexDirection: 'row', alignItems: 'center', justifyContent: 'center',zIndex:11000
        }}>
            <View style={childPositionStyle}>
                {props.children}
            </View>
            <TouchableOpacity onPress={onClose}
                              style={{
                                  position: 'absolute', backgroundColor: THEME_COLORS.shadow4,
                                  zIndex: 1, top: 0, bottom: 0, left: 0, right: 0
                              }}/>
        </View>,
        appRoot
    );
};

export default Dropdown;
